module.exports = __webpack_public_path__ + "assets/57983feec8e72aca143b439118a5a1ac.png";